<template>
  <div id="app">
    <!-- Используем зарегистрированный компонент DashboardView -->
    <DashboardView />
  </div>
</template>

<script>
import DashboardView from './components/DashboardView.vue'

export default {
  name: 'App',
  components: {
    DashboardView
  }
}
</script>

<style>
/* Глобальные стили для приложения */
</style>